import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const Members = lazy(() => import('./Members'));
const MemberNew = lazy(() => import('./member/MemberNew'));
const MemberView = lazy(() => import('./member/MemberEdit'));
const MemberEditForm = lazy(() => import('./member/MemberFormWrapper'));
const MemberBills = lazy(() => import('./bills/Bills'));

export const memberRoutes: RouteObject[] = [
  {
    path: 'members',
    children: [
      { index: true, element: <Members /> },
      { path: 'new', element: <MemberNew /> },
      { path: ':memberId', element: <MemberView /> },
      { path: ':memberId/edit', element: <MemberEditForm /> },
      { path: ':memberId/bills', element: <MemberBills /> },
    ],
  },
];
